<template>
  <div
    class="horizontal-layout page-header-light horizontal-menu 1-column forgot-bg blank-page blank-page"
    data-open="click"
    data-menu="horizontal-menu"
    data-col="1-column"
  >
    <div class="row">
      <div class="col s12">
        <div class="container">
          <div id="forgot-password" class="row">
            <div
              class="col s12 m6 l4 z-depth-4 offset-m4 card-panel border-radius-6 forgot-card bg-opacity-8"
              style="min-height:360px"
            >
              <form class="login-form">
                <div class="row">
                  <div class="input-field col s12">
                    <h5 class="ml-4">Forgot Password</h5>
                  </div>
                </div>
                <div class="row margin form-input-div">
                  <div class="input-field col s12">
                    <i class="material-icons prefix pt-2">person_outline</i>
                    <input
                      id="email"
                      @keyup="errorMessage=''"
                      v-model="email"
                      name="uname"
                      type="email"
                    />
                    <label for="email" class="center-align">Email</label>
                  </div>
                </div>
                <div class="row mar">
                  <div class="input-field col s12">
                    <span class="error-message text-center" v-if="showErrMsg">{{errorMessage}}</span>
                    <button
                      type="submit"
                      v-loader-button="isLoading"
                      name="action"
                      class="btn waves-effect waves-light gradient-45deg-purple-deep-orange col s12 mb-1"
                    >
                      Reset
                      Password
                    </button>
                  </div>
                </div>
                <div class="row">
                  <div class="input-field col s12 m12 l12">
                    <p
                      class="margin medium-small right-align"
                      @click="$router.push({path:'/login'})"
                    >
                      <a class="pointer">Back to Login ?</a>
                    </p>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: "",
      showErrMsg: false,
      isLoading: false,
      errorMessage: ""
    };
  },
  created() {
    this.initJs();
  },
  methods: {
    initJs() {
      // this.$router.push({path: '/app/dashboard'});
      setTimeout(() => {
        $(() => {
          $(".login-form").validate({
            rules: {
              uname: {
                required: true
              }
            },
            //For custom messages
            messages: {
              uname: {
                required: "Email address is required"
              },

              password: {
                required: "Password is required",
                minlength: "Please enter at least 5 characters"
              }
            },
            errorElement: "div",
            errorPlacement: function(error, element) {
              var placement = $(element).data("error");
              if (placement) {
                $(placement).append(error);
              } else {
                error.insertAfter(element);
              }
            },
            submitHandler: e => {
              $("button").attr("disabled", "disabled");
              setTimeout(() => {
                $("button").removeAttr("disabled");
              }, 500);
              this.forgotPassword();
              return false;
            }
          });
        });
      }, 500);
    },
    forgotPassword() {
      this.showErrMsg = false;
      this.isLoading = true;
      ajax.post(
        Constants.default.APIURL.ForgotPassword,
        {
          email: this.email
        },
        res => {
          this.isLoading = false;
          Vue.toast("Password reset link has been sent to your mail address.",'toast-success');
          this.$router.push({
            path: "/login"
          });
        },
        err => {
          this.showErrMsg = true;
          this.isLoading = false;
          this.errorMessage = Vue.errorHandler(err);
          // Vue.toast(this.errorMessage);
        }
      );
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./../../public/assets/css/pages/forgot.css";
</style>
